var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ax-header-search-result-link"},[(!_vm.disabled)?_c('RouterLink',{staticClass:"search-result-link",attrs:{"to":_vm.route}},[_c('AxHeaderSearchResult',{attrs:{"result":_vm.result,"query":_vm.query}})],1):_c('div',[_c('AxHeaderSearchResult',{attrs:{"result":_vm.result,"query":_vm.query}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }